import { Directive, ElementRef, Renderer2, Input } from "@angular/core";

@Directive(
    { 
        standalone: false,
        selector: '[showWhen]' 
    }
)
export class ShowWhenDirective {
    constructor(private el: ElementRef, private renderer: Renderer2) { }

    @Input() set showWhen(condition: boolean) {
        if (condition) {
            this.renderer.removeStyle(this.el.nativeElement, 'display');
        } else {
            this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
        }
    }
}

